var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"merchant-help-tree-container"},[_c('el-scrollbar',{staticClass:"merchant-help-tree-scrollbar"},[_c('el-tree',{attrs:{"data":_vm.helpConfigTreeList,"node-key":"id","props":_vm.configProps,"icon-class":"help-expand-icon"},on:{"node-click":_vm.handleNodeClick},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('span',{staticClass:"merchant-help-tree-item",class:{ 'is-active': _vm.selectItem && data.id == _vm.selectItem.id }},[_vm._v("\n        "+_vm._s(node.label)+"\n      ")])}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e6e9e97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/help/components/merchant-help-tree.vue
// module id = null
// module chunks = 